<template>
  <div class="libraryContent">
    <!-- <div class="onlineNav"> -->
    <div class="nav">
      <headers class="herderNav" ref="header" :isChange="false" />
    </div>

    <!-- <div class="searchNav">
        <h1>海量GMAT题库 · 做题搜题一网打尽</h1>
        <div class="titTag">
          <a class="scoreTag">题库总题数9k+</a>
          <a>模考仿真度99%</a>
          <a class="scoreLast">题库更新频率day by day</a>
        </div>
        <div class="searchInput"><input placeholder="搜索包括不限于以下题源：OG PREP破解版（07/08/12） GWD Manhattan Advanced 300 杨鹏长难句……等市面全部主流题源" @click="goSearch" /></div>
        <div class="searchText">部分题源会配备真人视频逐题讲解哦，做GMAT，我们是用心的</div>
      </div> -->
    <!-- </div> -->
    <div class="libraryCon">
      <div class="libraryConLeft">
        <!-- 题目内容 -->
        <div
          :class="
            disabled_course_ids.includes(courseid) &&
            disabled_textbook_ids.includes(textbookid)
              ? 'moh'
              : 'ConLeftNav'
          "
        >
          <h2>题目内容</h2>
          <div
            class="subjectCard"
            :class="
              objContent.t_id == 4 && !objContent.pay
                ? objContent.a_type == 1
                  ? 'charge,mosaic'
                  : 'mosaic'
                : objContent.a_type == 1
                ? 'charge'
                : ''
            "
          >
            <div
              v-html="objContent.title"
              class="upCss"
              v-if="objContent.type != 8"
            ></div>
            <div v-if="objContent.type == 8 && reasoningList.length != 0">
              <el-tabs
                v-model="choosed"
                type="border-card"
                style="margin: 50px 0"
              >
                <el-tab-pane
                  :label="item.reasoning_title"
                  :name="index + ''"
                  v-for="(item, index) in reasoningList"
                  :key="index"
                >
                  <div v-html="item.reasoning_content"></div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div v-if="objContent.type == 6">
              <div
                v-for="(ele, index) in objContent.answer"
                :key="index"
                style="display: flex"
              >
                <div style="margin-bottom: 20px">
                  {{ objContent.opt[index] ? objContent.opt[index] + "." : "" }}
                  {{ ele.title }}
                  <el-select
                    size="small"
                    placeholder="Select"
                    v-model="choice[index][0]"
                  >
                    <el-option
                      v-for="(item, idx) in ele.option"
                      :key="idx"
                      :label="item"
                      :value="item"
                    >
                    </el-option> </el-select
                  >{{ ele.title2 }}
                  <el-select
                    size="small"
                    placeholder="Select"
                    v-model="choice[index][1]"
                    v-if="ele.option2.length != 0"
                  >
                    <el-option
                      v-for="(item, idx) in ele.option2"
                      :key="idx"
                      :label="item"
                      :value="item"
                    >
                    </el-option> </el-select
                  >{{ ele.title3 }}
                </div>
              </div>
            </div>
            <div class="rightChoice">
              <div
                v-html="objContent.stem"
                class="upCss"
                v-if="objContent.type != 7"
                style="margin: 20px 0"
              ></div>
              <div class="choiceT doubleChoice" v-if="objContent.type == 3">
                <el-table :data="tableData" border>
                  <el-table-column prop="english" width="70"></el-table-column>
                  <el-table-column :label="objContent.yes">
                    <template slot-scope="scope">
                      <el-checkbox
                        border
                        v-model="zanswer.firstRadio"
                        @change="radioChange"
                        :label="scope.$index"
                        >{{ "" }}
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column :label="objContent.no">
                    <template slot-scope="scope">
                      <el-checkbox
                        border
                        v-model="zanswer.secondRadio"
                        @change="radioChange"
                        :label="scope.$index"
                        >{{ "" }}
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="value"></el-table-column>
                </el-table>
              </div>
              <div class="choiceT doubleChoice" v-if="objContent.type == 9">
                <el-table
                  :data="tableData"
                  border
                  style="width: 100% !important"
                >
                  <el-table-column prop="english" width="70"></el-table-column>
                  <el-table-column :label="objContent.yes">
                    <template slot-scope="scope">
                      <el-checkbox
                        border
                        v-model="zanswer.firstRadio"
                        @change="radioChange('yes', scope.$index)"
                        :label="scope.$index"
                        >{{ "" }}
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column :label="objContent.no">
                    <template slot-scope="scope">
                      <el-checkbox
                        border
                        v-model="zanswer.secondRadio"
                        @change="radioChange('no', scope.$index)"
                        :label="scope.$index"
                        >{{ "" }}
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="value">
                    <template slot="header" slot-scope="scope">
                      <div
                        v-html="objContent.answer[0][0].replace(/\n/g, '<br>')"
                      ></div>
                    </template>
                    <template slot-scope="scope">
                      <div
                        v-html="scope.row.value.replace(/\n/g, '<br>')"
                      ></div> </template
                  ></el-table-column>
                  <el-table-column prop="value1">
                    <template slot="header" slot-scope="scope">
                      <div
                        v-html="objContent.answer[0][1].replace(/\n/g, '<br>')"
                      ></div> </template
                    ><template slot-scope="scope">
                      <div
                        v-html="scope.row.value1.replace(/\n/g, '<br>')"
                      ></div> </template
                  ></el-table-column>
                </el-table>
              </div>

              <div class="xanswer" v-if="objContent.type == 8">
                <div v-if="tableData.length != 0">
                  <div></div>
                  <el-table :data="tableData" border class="xtable1">
                    <el-table-column prop="date" :label="objContent.yes">
                      <template slot-scope="scope">
                        <el-radio
                          border
                          v-model="answers[0][scope.$index]"
                          label="0"
                          class="xradio"
                          >{{ "" }}</el-radio
                        >
                      </template>
                    </el-table-column>
                    <el-table-column :label="objContent.no">
                      <template slot-scope="scope">
                        <el-radio
                          border
                          v-model="answers[0][scope.$index]"
                          label="1"
                          class="xradio"
                          >{{ "" }}</el-radio
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="value"></el-table-column>
                  </el-table>
                </div>

                <div v-if="objContent.type == 8">
                  <div v-if="choiceList.length != 0">
                    <div style="margin-top: 50px"></div>
                    <el-radio-group v-model="answers[1][0]">
                      <div
                        v-for="(item, index) in choiceList"
                        :key="index"
                        style="margin-top: 20px"
                      >
                        <el-radio :label="index">
                          <span>
                            {{ item.value }}
                          </span>
                        </el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div
                v-if="objContent.type == 7 && table.length != 0"
                style="margin-bottom: 50px"
              >
                <el-table
                  :header-cell-style="{ textAlign: 'center' }"
                  :data="table"
                  :show-summary="objContent.table_status == 1"
                  :summary-method="getSummaries"
                  border
                >
                  <template v-if="status">
                    <el-table-column
                      :prop="item.list.length == 0 ? `name${item.index}` : '0'"
                      :label="item.value"
                      v-for="(item, index) in tableList"
                      :key="index"
                      :sortable="item.list.length == 0"
                    >
                      <template slot="header">
                        <span
                          v-html="
                            item.value.charAt(item.value.length - 2) == '/'
                              ? `${item.value.slice(
                                  0,
                                  -2
                                )}<sup>${item.value.charAt(
                                  item.value.length - 1
                                )}</sup>`
                              : item.value
                          "
                        >
                        </span>
                      </template>
                      <el-table-column
                        v-if="item.list.length > 0"
                        :prop="`name${v.index}`"
                        :label="v.value"
                        sortable
                        v-for="(v, idx) in item.list"
                        :key="idx"
                      >
                        <template slot="header">
                          <span
                            v-html="
                              v.value.charAt(v.value.length - 2) == '/'
                                ? `${v.value.slice(0, -2)}<sup>${v.value.charAt(
                                    v.value.length - 1
                                  )}</sup>`
                                : v.value
                            "
                          >
                          </span>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </template>

                  <div v-else v-for="(item, index) in tableList" :key="index">
                    <el-table-column
                      v-if="item.list.length > 0"
                      :prop="index + '-' + idx"
                      :label="v"
                      sortable
                      :fixed="idx == 0"
                      v-for="(v, idx) in item.list"
                      :key="idx"
                    >
                      <template slot="header">
                        <span
                          v-html="
                            v.charAt(v.length - 2) == '/'
                              ? `${v.slice(0, -2)}<sup>${v.charAt(
                                  v.length - 1
                                )}</sup>`
                              : v
                          "
                        >
                        </span>
                      </template>
                    </el-table-column>
                  </div>
                </el-table>
              </div>
              <div
                v-html="objContent.stem"
                class="upCss"
                v-if="objContent.type == 7"
                style="margin: 20px 0"
              ></div>
              <div class="choiceT xanswer" v-if="objContent.type == 7">
                <el-table :data="tableData" border class="tableVue">
                  <el-table-column prop="date" :label="objContent.yes">
                    <template slot-scope="scope">
                      <!-- <div
                  style="width: 12px; height: 12px; border: 1px solid red;margin:0 auto" @click="handleClick(scope.row)"
                ></div> -->
                      <!-- <input @click="handleClick(scope.$index)" v-model="" type='radio' name='test' id='test1' /> -->
                      <el-radio
                        border
                        v-model="answers[scope.$index]"
                        label="0"
                        class="xradio"
                        >{{ "" }}</el-radio
                      >
                    </template>
                  </el-table-column>
                  <el-table-column :label="objContent.no">
                    <template slot-scope="scope">
                      <!-- <div
                  style="width: 12px; height: 12px; border: 1px solid red;margin:0 auto"
                ></div> -->
                      <!-- <input @click="handleClick(scope.$index)" v-model="answer[scope.$index]" type='radio' name='test' id='test1' /> -->
                      <el-radio
                        border
                        v-model="answers[scope.$index]"
                        label="1"
                        >{{ "" }}</el-radio
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="value"></el-table-column>
                </el-table>
              </div>
              <el-checkbox-group v-model="checkList" class="checkboxs">
                <div
                  v-for="(answer, indexer) in objContent.answer"
                  :key="indexer"
                  class="answe"
                >
                  <!-- 双 -->
                  <select
                    style="
                      width: 160px;
                      border: 1px solid #e5e5e5;
                      margin-top: 10px;
                      background: #fff;
                      font-family: inherit;
                      resize: none;
                    "
                    v-if="objContent.type == 2"
                  >
                    <option value="select...">select...</option>
                    <option
                      :value="audi"
                      v-for="(item, index) in answer"
                      :key="index"
                    >
                      {{ item }}
                    </option>
                  </select>
                  <!-- 单选 -->
                  <span v-if="objContent.type == 1">
                    <el-radio
                      v-model="radio"
                      :label="indexer"
                      class="radio"
                      style="font-weight: 550; color: #000"
                    >
                      {{ objContent.opt[indexer] }}</el-radio
                    >
                  </span>
                  <span
                    v-html="answer"
                    v-if="objContent.type == 1"
                    style="font-size: 14px"
                  ></span>
                  <!-- 多选 -->
                  <!-- <el-checkbox border :label="indexer" v-if="objContent.type == 3">{{
                  ""
                }}</el-checkbox>
                <div
                  v-html="answer"
                  style="display: inline-block; font-size: 14px"
                  v-if="objContent.type == 3"
                ></div> -->
                </div>
              </el-checkbox-group>
            </div>
          </div>

          <div class="ConLeftNavUnder">
            <!-- <div>查看答案</div> -->
            <div>
              <el-button @click="answerButton" v-if="!answer"
                >显示答案</el-button
              >
              <span v-if="answer"
                >正确答案:
                <span v-if="objContent.type === 1">
                  <span
                    v-for="(item, index) in objContent.ranswer"
                    :key="index"
                  >
                    <span>{{ lists[item] }}</span>
                    <!-- <div v-html="objContent.answer[item].replace(/\n/g, '<br>')"></div> -->
                  </span>
                </span>
                <span v-else-if="objContent.type === 7">
                  <span v-for="(z, i) in objContent.ranswer" :key="i">
                    {{ z % 2 == 0 ? objContent.yes : objContent.no }}
                  </span>
                </span>
                <span v-else-if="objContent.type === 9">
                  <span v-for="(z, i) in objContent.ranswer" :key="i">
                    {{
                      z % 2 == 0
                        ? english[i] + " " + objContent.yes
                        : english[i] + " " + objContent.no
                    }}
                  </span>
                </span>
                <div v-else-if="objContent.type === 2">
                  <span
                    v-for="(item, index) in objContent.ranswer"
                    :key="index"
                  >
                    <span v-for="(item2, index2) in item" :key="index2">
                      <div
                        v-html="
                          objContent.answer[index][item2].replace(/\n/g, '<br>')
                        "
                      ></div> </span
                    ><br />
                  </span>
                </div>
                <div v-else-if="objContent.type === 3 || objContent.type === 4">
                  <div>
                    <br />
                    <span style="margin-right: 10px"
                      >{{ objContent.yes }}:</span
                    >
                    <div
                      v-for="(item, index) in objContent.ranswer"
                      :key="index"
                      style="
                        width: 800px;
                        margin: 5px auto 0;
                        padding-left: 40px;
                      "
                      v-if="parseInt(item) % 2 === 0"
                    >
                      <div
                        v-html="
                          objContent.answer[parseInt(item / 2)].replace(
                            /\n/g,
                            '<br>'
                          )
                        "
                      ></div>
                    </div>
                    <br />
                  </div>
                  <div>
                    <span style="margin-right: 10px">{{ objContent.no }}:</span>
                    <div
                      v-for="(item, index) in objContent.ranswer"
                      :key="index"
                      style="
                        width: 800px;
                        margin: 5px auto 0;
                        padding-left: 40px;
                      "
                      v-if="parseInt(item) % 2 === 1"
                    >
                      <div
                        v-html="
                          objContent.answer[parseInt(item / 2)].replace(
                            /\n/g,
                            '<br>'
                          )
                        "
                      ></div>
                    </div>
                    <br />
                  </div>
                </div>
                <div
                  v-else-if="objContent.type === 5"
                  v-html="objContent.ranswer[0].replace(/\n/g, '<br>')"
                ></div>
                <div
                  v-else-if="objContent.type == 6"
                  style="width: 800px; margin: 0 auto; padding-left: 40px"
                >
                  <div v-for="(item, index) in objContent.ranswer" :key="index">
                    <span style="margin-right: 20px; margin-left: 0">{{
                      item[0]
                    }}</span>
                    <span v-if="item[1]">{{ item[1] }}</span>
                  </div>
                </div>
                <div
                  v-else-if="objContent.type == 8"
                  style="width: 800px; margin: 0 auto; padding-left: 40px"
                >
                  <div
                    v-for="(item, index) in objContent.ranswer"
                    :key="index"
                    style="margin-top: 5px"
                  >
                    <div v-if="item.length != 0">
                      <!-- {{ index == 0 ? "判断题：" : "单选题：" }} -->
                      <div v-for="y in item">
                        <div v-if="index == 0">
                          {{ y % 2 == 0 ? objContent.yes : objContent.no }}
                        </div>
                        <div v-else>
                          {{ objContent.answer[index][y * 1] }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <span>
                <!-- <el-button plain>添加做笔记</el-button> -->
                <el-button
                  type="primary"
                  v-if="objContent.next"
                  plain
                  @click="NextQuestion"
                  >下一题</el-button
                >
              </span>
            </div>
          </div>
        </div>
        <!-- 精选解析 -->
        <div class="LeftanalysisOne">
          <div class="LeftanalysisCon">
            <h2>精选解析</h2>
            <div class="analysisText" v-html="objContent.analysis"></div>
            <div class="analysisBtn"></div>
          </div>
        </div>
        <!-- 讨论 -->
        <!-- <div class="Leftanalysis">
          <div class="LeftanalysisCon">
            <div class="analysisDiscussUser">
              <img src="../../assets/allSubject/userPicture.png" />
              <p class="userNickname">画画撒大针对SC题目</p>
              <p>已输入{{ userInputScore }}个字</p>
            </div>
            <textarea type="text" class="inputs" v-model="userInput" placeholder="我要讨论/提问  (限400字)" maxlength="400" />
            <div class="userBtns">
              <el-checkbox border v-model="checked" radio>标记为提问，会有更大神为你解答</el-checkbox>
              <button>发送</button>
            </div>
            <h1>问题讨论</h1>
            <div class="discussCards">
              <div class="discussCardsNav">
                <img src="../../assets/allSubject/userPicture.png" />
                <p>画画撒大针对SC题目</p>
              </div>
              <div class="discussCardsCon">
                <p>
                  句子结构：在……ECS期间，坚定的倡导者……通过暗示…… 。A就像她当时那样..没有同位语简洁，在她的建议下，
                  她的建议里被建议的丑闻很多支持者，也没有通过暗示，这么个动作更好一点，只能对比出来
                </p>
                <p>A 正确1</p>
                <p>B 正确2</p>
                <p>C 正确3</p>
                <p>D 正确4</p>
                <div class="pariseNews">
                  <div class="parise">
                    <div class="parise">
                      <img src="../../assets/parise.png" />
                      <p>1353</p>
                    </div>
                    <div class="parise" style="margin-left: 25px;">
                      <img src="../../assets/news.png" />
                      <p>回复</p>
                    </div>
                  </div>
                  <span>2014-12-02 09:10:20</span>
                </div>
              </div>
            </div>
            <div class="discussCardsCon CardConsTop">
              <div class="discussCardsNav">
                <img src="../../assets/allSubject/userPicture.png" />
                <p>54465441</p>
                <p>回复</p>
                <p>画画撒大针对SC题目</p>
              </div>
              <p class="CardConsTopInfos">
                句子结构：在……ECS期间，坚定的倡导者……通过暗示…… 。A就像她当时那样..没有同位语简洁，在她的建议下，在她的建议里被建议的丑闻很多支持者，也没有通过暗示，
                这么个动作更好一点只能对比出来B的后面结构太复杂C尴尬D正确E she双主语
              </p>
              <div class="pariseNews CardConsTopInfos">
                <div class="parise">
                  <div class="parise">
                    <img src="../../assets/parise.png" />
                    <p>1353</p>
                  </div>
                  <div class="parise" style="margin-left: 25px;">
                    <img src="../../assets/news.png" />
                    <p>回复</p>
                  </div>
                </div>
                <span>2014-12-02 09:10:20</span>
              </div>
            </div>

            <div class="userReply">
              <textarea type="text" class="inputs" v-model="userReply" placeholder="我要回复  (限400字)" maxlength="400" />
              <div class="userBtns">
                <button>取消</button>
                <button class="sendOut">发送</button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 右侧 -->
      <div class="libraryConRight">
        <div class="rightCardOne">
          <!-- <div class="allCardTits"><h1>选择材料</h1></div>
                <div class="CardOneCon">
                  <div class="cardSelect">
                    <el-select v-model="value" placeholder="请选择" style="width: 182px !important;height: 40px !important;"@change="sele">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="valueTwo" placeholder="请选择" style="width: 93px !important;height: 40px !important;"@change="sele">
                      <el-option v-for="item in optionsTwo" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                  <div class="setTitBtn">Set01</div>
                  <div class="choiceBtns"><div v-for="ele in 100">1</div></div> -->
          <div class="CardOneConUnder">
            <h1 style="font-size: 16px">题目来源</h1>
            <div
              style="margin: 0 10px 10px 10px; font-size: 15px"
              v-if="objContent.textbook"
            >
              {{ objContent.textbook.title }}
            </div>
            <h1 style="font-size: 16px">知识点</h1>
            <div v-if="objContent.knowledges" style="margin: 0 10px 10px 10px">
              <span
                style="font-size: 15px"
                v-for="(item, index) in objContent.knowledges"
                :key="index"
              >
                {{ item.title }}
              </span>
            </div>
            <!-- <div class="CardOneConUnderBtns">
                <p>正确率：{{ objContent.average }}%</p>
                <div class="CardEvaluates">
                  <p>困难度:</p>
                  <div class="Cardevaluate">{{ objContent.difficulty | difficult }}</div>
                </div>
              </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="rightCardTwo">
          <div class="rightCardTwoCon">
            <h1>最新提问</h1>
            <div class="CardTwoContent" v-for="item in 8">
              <img src="../../assets/allSubject/userPicture.png" />
              <div>
                <p>画画撒大针对SC题目</p>
                <p class="CardTwounder">
                  发表了一个提问
                  <span>去解答>></span>
                </p>
              </div>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../../api/subject.js";
import headers from "../../components/header.vue";
import searchNav from "../../components/searchNav.vue";
import apis from "../../api/personallnfo.js";

export default {
  components: {
    headers,
    searchNav,
  },
  updated() {
    // this.getInfo();
    let $ps = $(".upCss>p>span");
    $ps.css({
      fontFamily: "微软雅黑",
      // "line-height":"18px",
      "margin-bottom": "20px",
    });
  },
  data() {
    return {
      status: false,
      english: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      zanswer: {
        firstRadio: [],
        secondRadio: [],
      },
      reasoningList: [],
      table: [],
      answers: [[], []],
      tableData: [],
      choice: [],
      checkList: [],
      radio: -1,
      lists: ["A", "B", "C", "D", "E", "F", "G"],
      navCodes: require("@/assets/login/whiteCode.png"),
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      checked: false,
      //用户输入
      userInput: "",
      //用户回复
      userReply: "",
      //用户输入字体的个数
      userInputScore: 0,
      options: [
        {
          value: "PREEP07 Test 11",
          label: "PREEP07 Test 1",
        },
        {
          value: "PREEP07 Test 2",
          label: "PREEP07 Test 2",
        },
      ],
      value: "",
      optionsTwo: [
        {
          value: "SC",
          label: "SC",
        },
        {
          value: "DZ",
          label: "DZ",
        },
      ],
      valueTwo: "",
      subjectId: null,
      objContent: {
        table_list: [],
      },
      tableList: [],
      answer: false,
      choosed: 0,
      choiceList: [],
      bottomTableList: [],
      disabled_course_ids: "",
      courseid: null,
      disabled_textbook_ids: "",
      textbookid: null,
    };
  },
  // watch: {
  //   userInput(oldVal, newVal) {
  //     this.userInputScore = oldVal.length;
  //   }
  // },
  mounted() {
    this.getInfo();
  },
  watch: {
    userInput(newVal, oldVal) {
      this.userInputScore = newVal.length;
    },
    $route(to, from) {
      if (this.$route.params.id) {
        this.radio = -1;
        this.checkList = [];
        this.getData();
      }
    },
  },
  filters: {
    difficult(i) {
      switch (i) {
        case 0:
          return "简单";
        case 1:
          return "一般";
        case 2:
          return "困难";
      }
    },
  },
  methods: {
    getInfo() {
      apis
        .getPersonInfo()
        .then((res) => {
          console.log(res.data.data.disabled_course_ids);
          console.log(res.data.data.disabled_textbook_ids);
          this.disabled_course_ids = res.data.data.disabled_course_ids;
          this.disabled_textbook_ids = res.data.data.disabled_textbook_ids;
        })
        .catch((err) => {
          this.$router.push("/login");
        });
    },
    sele() {
      let { value, valueTwo } = this;
      if (
        value === undefined ||
        value === "" ||
        valueTwo === undefined ||
        valueTwo === ""
      ) {
        console.log(value, valueTwo);
      } else {
      }
    },
    radioChange(item, index) {
      if (this.disabled_course_ids.includes(this.courseid)) {
        return;
      }
      console.log(index);
      // if (this.objContent.type == 9 && this.objContent.table_status == 0) {
      //   let num = -1;
      //   if (item == "yes") {
      //     this.zanswer.secondRadio.forEach((x, y) => {
      //       if (x === index) {
      //         num = y;
      //       }
      //     });
      //     if (num != -1) {
      //       this.zanswer.secondRadio.splice(num, 1);
      //     }
      //   } else {
      //     this.zanswer.firstRadio.forEach((x, y) => {
      //       console.log(x, index);
      //       if (x === index) {
      //         num = y;
      //       }
      //     });
      //     if (num != -1) {
      //       this.zanswer.firstRadio.splice(num, 1);
      //     }
      //   }
      //   return;
      // }
      if (this.zanswer.firstRadio.length > 1) {
        this.zanswer.firstRadio.splice(0, this.zanswer.firstRadio.length - 1);
      }
      if (this.zanswer.secondRadio.length > 1) {
        this.zanswer.secondRadio.splice(0, this.zanswer.secondRadio.length - 1);
      }
    },
    //跳转搜索
    goSearch() {
      this.$router.push("/searchMatter");
    },
    getReasoningList() {
      this.reasoningList = [];
      this.choosed = "0";

      this.$nextTick(() => {
        const nameList = [];
        this.objContent.reasoningList.forEach((item) => {
          if (!nameList.includes(item.reasoning_title)) {
            nameList.push(item.reasoning_title);
            this.reasoningList.push(item);
          }
        });
        for (const item of this.objContent.getReasoningList) {
          if (!nameList.includes(item.name)) {
            nameList.push(item.name);
            this.reasoningList.push({
              reasoning_title: item.name,
              reasoning_content: item.content,
            });
          }
        }
      });
    },
    //获取信息
    getData() {
      let params = {
        id: this.$route.params.id,
      };
      let query = this.$qs.stringify(params);
      api.getTopicInfos(query).then((res) => {
        console.log(res.data.data.course.id);
        console.log(res.data.data.textbook.id);
        this.courseid = res.data.data.course.id;
        this.textbookid = res.data.data.textbook.id;
        this.objContent = res.data.data;
        if (this.objContent.type == 8) {
          this.getReasoningList();
          this.tableData = this.objContent.answer[0].map((item, index) => {
            return {
              value: `${
                this.objContent.opt[0][index]
                  ? this.objContent.opt[0][index] + "."
                  : ""
              } ${item}`,
            };
          });
          console.log(this.tableData);
          this.choiceList = this.objContent.answer[1].map((item, index) => {
            return {
              value: `${
                this.objContent.opt[1][index]
                  ? this.objContent.opt[1][index] + "."
                  : ""
              } ${item}`,
            };
          });
          this.answers = this.objContent.answer.map((item) => {
            return [];
          });
        } else if (this.objContent.type == 6) {
          let list = [];
          this.objContent.answer.forEach((element, index) => {
            list[index] = [];
            list[index].push("");
            if (element.option2.length != 0) {
              list[index].push("");
            }
          });
          this.choice = list;
        } else if (this.objContent.type == 7) {
          this.getTable();
          this.answers = this.objContent.answer.map((item) => {
            return "";
          });
          this.tableData = this.objContent.answer.map((item) => {
            return {
              value: item,
            };
          });
        } else if (this.objContent.type == 9) {
          let answer = JSON.parse(JSON.stringify(this.objContent.answer));
          answer.splice(0, 1);
          this.tableData = answer.map((item, index) => {
            return {
              english: this.english[index],
              value: item[0],
              value1: item[1],
            };
          });
        } else if (this.objContent.type == 3) {
          this.tableData = this.objContent.answer.map((item, index) => {
            return {
              english: this.english[index],
              value: item,
            };
          });
        }
      });
    },
    getSummaries() {
      return this.bottomTableList;
    },
    getTable() {
      if (this.objContent.table_status == 1) {
        this.bottomTableList =
          this.objContent.table_list[this.objContent.table_list.length - 1];
        this.objContent.table_list.pop();
      }
      let name = [];
      this.tableList = [];
      this.table = [];
      let indexList = [];
      let list = [];
      this.status = false;
      this.$nextTick(() => {
        this.objContent.table_list[0].forEach((item) => {
          if (item) {
            this.status = true;
          }
        });
        if (this.status) {
          let num = [];
          this.objContent.table_list[0].forEach((item, index) => {
            if (item == "" && this.objContent.table_list[1][index] != "") {
              this.tableList.push({
                index,
                value: this.objContent.table_list[1][index],
                list: [],
              });
            } else {
              let ressult = false;
              this.objContent.table_list[0].forEach((z, i) => {
                if (item != "" && z != "" && item == z && i != index) {
                  console.log(z, item, index, i);
                  ressult = true;
                  if (num.length == 0) {
                    num.push({
                      value: item,
                      length: this.tableList.length,
                      list: [index],
                    });
                    this.tableList.push({
                      index: index,
                      value: item,
                      list: [
                        {
                          index: index,
                          value: this.objContent.table_list[1][index],
                        },
                      ],
                    });
                  } else {
                    let xRes = false;
                    let xRes1 = false;
                    num.forEach((res) => {
                      if (res.value == item) {
                        let result = false;
                        for (let x = 0; x < res.list.length; x++) {
                          if (res.list[x] == index) {
                            result = true;
                          }
                        }
                        if (!result) {
                          this.tableList[res.length].list.push({
                            index: index,
                            value: this.objContent.table_list[1][index],
                          });
                          res.list.push(index);
                        }
                        xRes1 = true;
                        xRes = false;
                      } else {
                        if (!xRes1) {
                          xRes = true;
                        }
                      }
                    });
                    if (xRes) {
                      num.push({
                        value: item,
                        length: this.tableList.length,
                        list: [index],
                      });
                      this.tableList.push({
                        index: index,
                        value: item,
                        list: [
                          {
                            index: index,
                            value: this.objContent.table_list[1][index],
                          },
                        ],
                      });
                    }
                  }
                }
              });
              if (!ressult) {
                this.tableList.push({
                  index: index,
                  value: item,
                  list: [
                    {
                      index: index,
                      value: this.objContent.table_list[1][index],
                    },
                  ],
                });
              }
            }
          });
          this.objContent.table_list.forEach((element, index) => {
            if (index != 0 && index != 1) {
              this.table.push({});
              element.forEach((item, idx) => {
                this.table[index - 2][`name${idx}`] =
                  item === "" ? item : isNaN(item * 1) ? item : item * 1;
              });
            }
          });
          console.log(this.table);
          return;
        }
        this.objContent.table_list.forEach((element, index) => {
          if (index != 0 && index != 1) {
            this.table.push({});
          }
          element.forEach((item, idx) => {
            if (index == 0) {
              if (item || idx === 0) {
                this.tableList.push({
                  index: item,
                  list: [],
                });
              }
              indexList.push(this.tableList.length - 1);
            } else if (index == 1) {
              this.tableList[indexList[idx]].list.push(item);
              let i =
                indexList[idx] +
                "-" +
                (this.tableList[indexList[idx]].list.length - 1);
              name.push(i);
            } else {
              this.table[index - 2][name[idx]] =
                item === "" ? item : isNaN(item * 1) ? item : item * 1;
            }
          });
        });
      });
    },
    //获取选择材料
    getSwitchData() {},
    //显示答案
    answerButton() {
      if (this.disabled_course_ids.includes(this.courseid)) {
        return;
      }
      // if (this.objContent.type == 9 && this.objContent.table_status == 0) {
      //   if (
      //     this.zanswer.firstRadio.length + this.zanswer.secondRadio.length ==
      //     this.tableData.length
      //   ) {
      //     this.answer = true;
      //   } else {
      //     this.$alert("需要先自行作出回答，才可跳出正确答案哦~", {
      //       confirmButtonText: "确定",
      //     });
      //   }
      //   return;
      // }
      if (this.objContent.type == 3 || this.objContent.type == 9) {
        if (
          this.zanswer.firstRadio.length + this.zanswer.secondRadio.length ==
          2
        ) {
          this.answer = true;
        } else {
          this.$alert("需要先自行作出回答，才可跳出正确答案哦~", {
            confirmButtonText: "确定",
          });
        }
        return;
      }
      if (this.objContent.type == 8) {
        var res = true;
        console.log(this.answers);
        if (
          (this.answers[1].length == 0 && this.choiceList.length != 0) ||
          this.answers[0].length != this.tableData.length
        ) {
          res = false;
        }
        this.answers[0].forEach((item) => {
          if (item == null) {
            res = false;
          }
        });
        if (res) {
          this.answer = true;
        } else {
          this.$alert("需要先自行作出回答，才可跳出正确答案哦~", {
            confirmButtonText: "确定",
          });
        }
        return;
      }
      if (this.objContent.type == 6) {
        let answers = true;
        this.choice.forEach((item) => [
          item.forEach((z) => {
            if (z == "") {
              answers = false;
            }
          }),
        ]);
        if (answers) {
          this.answer = true;
        } else {
          this.$alert("需要先自行作出回答，才可跳出正确答案哦~", {
            confirmButtonText: "确定",
          });
        }
        return;
      }
      if (this.objContent.type == 7) {
        let result = this.answers.every((item) => item != "");
        if (result) {
          this.answer = true;
        } else {
          this.$alert("需要先自行作出回答，才可跳出正确答案哦~", {
            confirmButtonText: "确定",
          });
        }
        return;
      }
      if (this.radio !== -1 || this.checkList.length != 0) {
        this.answer = true;
      } else {
        this.$alert("需要先自行作出回答，才可跳出正确答案哦~", {
          confirmButtonText: "确定",
        });
      }
      // console.log(this.answer)
    },
    //下一题弹框提示
    NextQuestion() {
      if (this.disabled_course_ids.includes(this.courseid)) {
        return;
      }
      this.tableData = [];

      this.answer = false;
      this.$router.push(`/libraryContent/${this.objContent.next}`);
    },
  },
  // mounted() {
  //   this.$refs.header.headerBack = {
  //     backgroundColor: '#fff'
  //   }
  //   this.$refs.header.herderTits = {
  //     color: 'rgb(102,102,102)'
  //   }
  //   this.$refs.header.headerIcon = require('@/assets/home/headerNav.png')
  //   if (this.$route.params.id) {
  //     this.getData();
  //   }
  // },
  mounted() {
    document.onkeydown = () => {
      //禁用F12
      if (window.event && window.event.keyCode == 123) {
        return false;
        //禁用ctrl+shift+i,
      } else if (
        window.event.ctrlKey &&
        window.event.shiftKey &&
        window.event.keyCode == 73
      ) {
        return false;
        //屏蔽Shift+F10
      } else if (window.event.shiftKey && window.event.keyCode == 121) {
        return false;
      }
    };
    document.oncontextmenu = new Function("event.returnValue=false");

    this.getInfo();

    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
    if (this.$route.params.id) {
      this.radio = -1;
      this.checkList = [];
      this.getData();
    }
  },
};
</script>

<style scoped>
@import url("../../assets/css/libraryContent.css");

.moh {
  filter: blur(5px);
  width: 880px;
  height: auto;
  background: #fff;
  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.moh::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background: rgba(255, 255, 255, .36); */
  z-index: 999;
}

.moh h2::after {
  content: "";
  width: 101px;
  height: 4px;
  border-bottom: 5px solid #49a0fe;
  display: block;
}

.moh h2 {
  font-size: ;
  font-weight: 400;
  color: #333333;
  margin-top: 25px;
  margin-left: 38px;
}

.mosaic {
  color: transparent;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/view/questionBank/libraryContent.vue